<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          {{ $t("app.general.config") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
      </el-breadcrumb>
      <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
    </div>

    <div class="col-md-12">
      <h4>{{ $t("app.general.config") }}</h4>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <!--
              <div class="card card_option" :class="isSelected(tabs.Notificaciones)">
                <div class="card-body" @click="tabSelected(tabs.Notificaciones)">
                  <label :class="isSelected(tabs.Notificaciones)">{{ $t('app.general.config_not') }}</label>
                </div>
              </div>-->
              <div class="card card_option" :class="isSelected(tabs.Usuarios)" v-if="user.isAdminEmpresarial">
                <div class="card-body" @click="tabSelected(tabs.Usuarios)">
                  <label :class="isSelected(tabs.Usuarios)">{{ $t('app.modules.users.title') }}</label>
                </div>
              </div>
              <div class="card card_option">
                <div class="card-body" @click="closeSesion">
                  <label>{{ $t('app.nav_bar.admin.account.close_session') }}</label>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-9">
          <div class="row">
            <div class="col-12" v-show="show === tabs.Notificaciones">
              <preferencias-notificaciones/>
            </div>
            <div class="col-12" v-if="user.isAdminEmpresarial" v-show="show === tabs.Usuarios">
              <lista-usuarios/>
              <usuario-add-edit/>
            </div>

          </div>
        </div>
      </div>
    </div>





    <!--<card>
      <el-tabs
        type="primary"
        tab-position="left"
        style="min-height: 300px; height: auto"
      >
        <el-tab-pane :label="$t('app.general.config_not')">
          <card v-for="f in this.prefs" :key="f.id">
            <div slot="header" class="clearfix">
              <b>{{ f.name }}</b>
            </div>
            <div class="form-group">
              <n-checkbox
                v-for="t in f.types"
                :key="t.idTipoNotificacion"
                :id="'cbx_'+f.id+'_'+t.idTipoNotificacion"
                class="col-md-3 float-left"
                :checked="t.idPreferenciaNotificacion > 0 ? true : false"
                @change="getValue(t.idPreferenciaNotificacion, f.id, t.idTipoNotificacion, $event)">
                {{ t.tipoNotificacion }}
              </n-checkbox>
            </div>
          </card>
          <div class="col-md-12 text-center">
            <n-button type="primary" class="btn btn-sm" @click.native="savePref">
              {{ $t("app.buttons.save") }}
            </n-button>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('app.modules.users.title')">




        </el-tab-pane>
        <el-tab-pane
          :label="$t('app.nav_bar.admin.account.close_session')"
          @click="closeSesion"
          >Task</el-tab-pane
        >
      </el-tabs>
    </card>-->
  </div>
</template>

<script>

export default {
  components: {
    PreferenciasNotificaciones: () => import("./preferenciasNotificaciones/preferenciasNotificaciones"),
    ListaUsuarios: () => import("./usuarios/listaUsuarios"),
    UsuarioAddEdit: () => import("./usuarios/usuarioAddEdit")
  },
  data() {
    return {
      user: null,
      tabs: {
        Notificaciones: 1,
        Usuarios: 2
      },
      show: 0
    };
  },
  created() {
    this.user = this.$store.state.user;
  },
  mounted() {
    //this.show = this.tabs.Notificaciones;
    this.show = this.tabs.Usuarios;
  },
  methods: {
    tabSelected(index){
      this.show = index;
    },
    isSelected(index){
      return index === this.show ? 'select' : '';
    },
    closeSesion() {
      this.$router.push({
        name: "Logout",
      });
    },
  },
};
</script>

<style scoped>
.breadcumb {
  margin: 10px 0 15px 0;
}

.card {
  border-radius: 12px !important;
}
.card_option {
  margin-bottom: 5px;
  cursor: pointer;
}
.card_option > div > label {
  cursor: pointer !important;
  color: #303133;
  font-weight: bold !important;
}

.card_option.select {
  background-color: red !important;
}
.card_option.select > div.card-body  {
  background-color: white !important;
  border-radius: 0 10px 10px 0 !important;
  margin-left: 6px;
}
.card-body.collapse_cat {
  padding: 0 !important;
}
.select {
  color: red !important;
}

</style>
